// import { useEffect } from "react";
// import ImageWithFallback from "@components/ui/ImageFallback";
// import {
//   BreakfastTime,
//   LunchTime,
//   DinnerTime,
//   AfternoonSnackTime,
//   EveningSnackTime,
//   Carbs,
//   Kcal,
//   NitroTech,
// } from "@utils/defaultImages";
// import ClockHand from "@components/ui/animations/Clock";
// import { useTranslation } from "react-i18next";
// import { useLocation, useNavigate } from "react-router-dom";
// import InfoGridCard from "@components/ui/InfoGridCard";
// import LiveClock from "./LiveClock";
// import { getInitialTab } from "@utils/getInitialTab";

// const today = new Date();
// const currentHour = today.getHours();

// const DietPlanOverview = ({
//   // Data props
//   selectedMeal,
//   selectedDay,
//   selectedMeals,

//   // Configuration props
//   variant = "dashboard", // "dashboard" or "mealListing"
//   showHeader = true,
//   showClock = true,

//   // Navigation props
//   navigateTo = "/dashboard/recipe-detail",
//   stateKey = "dashboard",

//   // State management
//   tab,
//   setTab,
// }) => {
//   const { t } = useTranslation();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const isCurrentMealTime = (category, type) => {
//     const currentTab = getInitialTab();
//     return currentTab.category === category && currentTab.type === type;
//   };

//   const handleCategoryChange = (newCategory) => {
//     const currentTimeTab = getInitialTab();

//     if (newCategory === currentTimeTab.category) {
//       setTab(currentTimeTab);
//     } else {
//       let newType;

//       if (newCategory === "meals") {
//         if (currentHour >= 19) {
//           newType = "dinner";
//         } else if (currentHour >= 13) {
//           newType = "lunch";
//         } else {
//           newType = "breakfast";
//         }
//       } else {
//         if (currentHour >= 16) {
//           newType = "evening";
//         } else {
//           newType = "afternoon";
//         }
//       }

//       setTab({
//         category: newCategory,
//         type: newType,
//       });
//     }
//   };

//   const handleTypeChange = (newType) => {
//     setTab((prev) => ({
//       ...prev,
//       type: newType,
//     }));
//   };

//   const handleOpenRecipe = () => {
//     const index = selectedMeals[selectedDay][tab.type];

//     navigate(navigateTo, {
//       state: {
//         mealType: tab.type,
//         index: index,
//         day: selectedDay,
//         [stateKey]: true,
//         tab: tab.type,
//         tabCategory: tab?.category,
//       },
//     });
//   };

//   useEffect(() => {
//     if (location.state?.tab) {
//       setTab({
//         category: location?.state?.category,
//         type: location.state?.tab,
//       });
//     }
//   }, [location?.state]);

//   const nutrientData = [
//     {
//       label: "Protein",
//       key: "Protein",
//       icon: <NitroTech className="min-w-[30px] min-h-[30px]" />,
//       unit: "g",
//       tabColor: "rgb(215 223 255)",
//       value:
//         tab.category === "meals"
//           ? selectedMeal?.nutrition?.[tab.type]?.Protein
//           : selectedMeal?.snacks?.[`${tab.type}_snacks`]?.Proteins,
//     },
//     {
//       label: "Calorie",
//       key: "calories",
//       icon: <Kcal className="min-w-[30px] min-h-[30px]" />,
//       unit: "kCal",
//       tabColor: "rgb(245 224 210)",
//       value:
//         tab.category === "meals"
//           ? selectedMeal?.calories?.[tab.type]
//           : selectedMeal?.snacks?.[`${tab.type}_snacks`]?.Calories,
//     },
//     {
//       label: "Carbs",
//       key: "Carbohydrates",
//       icon: <Carbs className="min-w-[30px] min-h-[30px]" />,
//       unit: "g",
//       tabColor: "rgb(208 241 255)",
//       value:
//         tab.category === "meals"
//           ? selectedMeal?.nutrition?.[tab.type]?.Carbohydrates
//           : selectedMeal?.snacks?.[`${tab.type}_snacks`]?.Carbohydrates,
//     },
//   ];

//   const getPunchLine = () => {
//     switch (tab.type) {
//       case "breakfast":
//         return t("dietPlanDashboard.mealListing.breakfastPunchLine");
//       case "afternoon":
//         return t("dietPlanDashboard.mealListing.afternoonSnackPunchLine");
//       case "lunch":
//         return t("dietPlanDashboard.mealListing.lunchPunchLine");
//       case "evening":
//         return t("dietPlanDashboard.mealListing.eveningSnackPunchLine");
//       case "dinner":
//         return t("dietPlanDashboard.mealListing.dinnerPunchLine");
//       default:
//         return "";
//     }
//   };

//   const getMealTimeText = () => {
//     if (!isCurrentMealTime(tab.category, tab.type)) return "";

//     switch (tab.type) {
//       case "breakfast":
//         return t("dietPlanDashboard.mealListing.breakfastTime");
//       case "afternoon":
//       case "evening":
//         return t("dietPlanDashboard.mealListing.snackTime");
//       case "lunch":
//         return t("dietPlanDashboard.mealListing.lunchTime");
//       case "dinner":
//         return t("dietPlanDashboard.mealListing.dinnerTime");
//       default:
//         return "";
//     }
//   };

//   return (
//     <div className={`${variant === "dashboard" ? "p-4 lg:p-6" : ""}`}>
//       {/* Header Section - Only for mealListing variant */}
//       {showHeader && variant === "mealListing" && (
//         <div
//           className="bg-white flex items-start justify-between py-[25px] px-[20px] rounded-md"
//           style={{
//             background:
//               "linear-gradient(150deg, #0771EF 12.89%, #15AAFC 85.22%)",
//           }}
//         >
//           <div className="flex flex-col gap-[5px] w-full">
//             <div className="flex flex-col md:flex-row lg:flex-col xl:flex-row justify-between">
//               <h1 className="text-[16px] lg:text-[14] xl:text-[16px] font-[700] font-[Lato] flex items-center gap-2 text-white">
//                 {showClock && <ClockHand className="w-7 h-7" />}
//                 {showClock && <LiveClock />}
//                 &nbsp;
//                 {getMealTimeText()}
//               </h1>
//               <div className="w-[fit-content] my-2 xl:my-0 px-[10px] lg:px-[10px] xl:px-[20px] text-[14px] md:text-[18px] text-[#0575E6] font-[Lato] font-[600] bg-white rounded-full flex items-center">
//                 {t(`days.${selectedDay.toLowerCase()}`)}
//               </div>
//             </div>

//             <h1 className="text-[14px] xl:text-[16px] font-[400] font-[Lato] text-white">
//               {t("dietPlanDashboard.mealListing.completeHeading")}
//             </h1>

//             <span className="inline-flex items-center rounded-full text-[14px] font-[Lato] font-[400] text-white">
//               {getPunchLine()}
//             </span>
//           </div>
//         </div>
//       )}

//       {/* Day Title - Only for dashboard variant */}
//       {variant === "dashboard" && (
//         <div className="flex items-center justify-between mb-4">
//           <p className="text-[16px] font-[Lato]">
//             <strong>{t(`days.${selectedDay.toLowerCase()}`)}'s</strong>{" "}
//             {t("dashboard.mealPlanOverview")}
//           </p>
//         </div>
//       )}

//       {/* Category Tabs */}
//       <div className="flex justify-center my-[10px]">
//         <div className="flex bg-white rounded-full p-1 border border-[#E9E9E9]">
//           {["meals", "snacks"].map((mealCat) => {
//             const isActive = tab.category === mealCat;
//             return (
//               <button
//                 key={mealCat}
//                 onClick={() => handleCategoryChange(mealCat)}
//                 className={`relative flex-1 px-6 py-2 text-sm rounded-full capitalize transition-all duration-300 min-w-[120px] text-center ${
//                   isActive
//                     ? "bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white"
//                     : "bg-white text-black"
//                 }`}
//               >
//                 <span className="flex items-center justify-center gap-2 relative">
//                   {mealCat === "meals"
//                     ? t("dietPlanDashboard.mealListing.mealTabName")
//                     : t("dietPlanDashboard.mealListing.snacksTabName")}
//                   {getInitialTab().category === mealCat && (
//                     <span className="relative flex h-2.5 w-2.5">
//                       <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
//                       <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500"></span>
//                     </span>
//                   )}
//                 </span>
//               </button>
//             );
//           })}
//         </div>
//       </div>

//       {/* Meal Type Buttons */}
//       {tab.category === "meals" ? (
//         <div className="grid grid-cols-3 lg:grid-cols-1 xl:grid-cols-3 gap-4 lg:gap-2 xl:gap-8 my-[10px]">
//           {["breakfast", "lunch", "dinner"].map((mealType) => (
//             <button
//               key={mealType}
//               onClick={() => handleTypeChange(mealType)}
//               className={`px-2 py-2 text-[12px] lg:text-[12px] xl:text-[14px] rounded-md capitalize relative ${
//                 tab.type === mealType
//                   ? "bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white"
//                   : "bg-white text-black border border-[2px] border-[#F2F2F2B8] hover:border-[#0575e6] hover:text-[#0575e6]"
//               }`}
//             >
//               <span className="flex items-center justify-center gap-2">
//                 {mealType === "breakfast" ? (
//                   <BreakfastTime className="min-w-5 min-h-5" />
//                 ) : mealType === "dinner" ? (
//                   <DinnerTime className="min-w-5 min-h-5" />
//                 ) : (
//                   <LunchTime className="min-w-5 min-h-5" />
//                 )}
//                 {t(
//                   `dietPlanDashboard.mealListing.Meals.${mealType.toLowerCase()}`
//                 )}
//                 {isCurrentMealTime("meals", mealType) && (
//                   <span className="relative flex h-3 w-3">
//                     <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
//                     <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
//                   </span>
//                 )}
//               </span>
//             </button>
//           ))}
//         </div>
//       ) : (
//         <div className="flex justify-center gap-4 lg:gap-2 xl:gap-4 my-[10px]">
//           {["afternoon", "evening"].map((snackType) => (
//             <button
//               key={snackType}
//               onClick={() => handleTypeChange(snackType)}
//               className={`w-[35%] px-4 py-2 text-[14px] lg:text-[12px] xl:text-[14px] rounded-md capitalize relative ${
//                 tab.type === snackType
//                   ? "bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white"
//                   : "bg-white text-black border border-[2px] border-[#F2F2F2B8] hover:border-[#0575e6] hover:text-[#0575e6]"
//               }`}
//             >
//               <span className="flex items-center justify-center gap-2">
//                 {snackType === "afternoon" ? (
//                   <AfternoonSnackTime />
//                 ) : (
//                   <EveningSnackTime />
//                 )}
//                 {t(`dietPlanDashboard.mealListing.Snacks.${snackType}`)}
//                 {isCurrentMealTime("snacks", snackType) && (
//                   <span className="relative flex h-3 w-3">
//                     <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
//                     <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
//                   </span>
//                 )}
//               </span>
//             </button>
//           ))}
//         </div>
//       )}

//       {/* Content Section */}
//       {tab.category === "meals" ? (
//         <>
//           <div className="w-[100%] relative">
//             <ImageWithFallback
//               src={`${selectedMeal.image?.[tab.type]}`}
//               alt={tab.type}
//               className="w-[100%] max-h-[300px] xl:max-h-[282px] min-h-[250px] rounded-lg !object-cover"
//             />
//             <div
//               className="absolute inset-0  rounded-[10px] z-[1]"
//               style={{
//                 background:
//                   "linear-gradient(180deg, rgba(102, 102, 102, 0) 0%, #000000 100%)",
//               }}
//             />
//             <div className="absolute top-[15px] right-[15px] flex justify-center z-[2]">
//               <button
//                 onClick={handleOpenRecipe}
//                 className="px-[20px] py-[10px] bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white rounded-[100px] text-[12px] sm:text-[14px] min-w-[120px] border border-white"
//               >
//                 {t("dietPlanDashboard.mealListing.viewDetails")}
//               </button>
//             </div>
//             <div className="absolute bottom-0 left-[15px] flex items-center justify-between mb-3 gap-2 z-[2]">
//               <h3 className="text-[22px] font-[Lato] font-[600] text-[white] max-w-[90%]">
//                 {selectedMeal.meal_name?.[tab.type]}
//               </h3>
//             </div>
//           </div>

//           <h3 className="text-[14px] font-[Lato] font-[600] mb-2 mt-[12px]">
//             {t("dietPlanDashboard.mealListing.mealNutrient")}
//           </h3>
//         </>
//       ) : (
//         <>
//           <div className="relative bg-white flex flex-col-reverse gap-[10px] rounded-[10px] mb-[10px]">
//             <div className="flex justify-center">
//               <ImageWithFallback
//                 src={`${
//                   selectedMeal.image?.[
//                     tab.type === "afternoon"
//                       ? "afternoon_snacks"
//                       : "evening_snacks"
//                   ]
//                 }`}
//                 alt={tab.type}
//                 className="w-[100%] max-h-[300px] xl:max-h-[285px] min-h-[300px] rounded-lg !object-cover"
//               />
//               <div
//                 className="absolute inset-0  rounded-[10px] z-[1]"
//                 style={{
//                   background:
//                     "linear-gradient(180deg, rgba(102, 102, 102, 0) 0%, #000000 100%)",
//                 }}
//               />

//               <div className="absolute bottom-[15px] left-[15px] flex justify-center z-[2]">
//                 <div
//                   className="flex flex-col justify-center gap-1 sm:gap-2 rounded-[20px] py-2 px-4"
//                   style={{
//                     background:
//                       "linear-gradient(112.83deg, rgba(255, 255, 255, 0.47) 0%, rgba(255, 255, 255, 0) 110.84%)",
//                   }}
//                 >
//                   {selectedMeal.snacks?.[
//                     `${tab.type}_snacks`
//                   ]?.SnackItems?.slice(0, 2)?.map((item, index) => (
//                     <div
//                       key={index}
//                       className="text-[#0575e6] cursor-default text-[12px] md:text-[16px] font-[Lato] font-[500] rounded-full px-2 sm:px-2 py-1 flex items-center gap-1 sm:gap-2 w-[fit-content] max-w-[200px] sm:max-w-[250px] xl:max-w-[350px]"
//                     >
//                       <p className="bg-white rounded-full w-7 h-7 flex items-center justify-center flex-shrink-0 text-[#696969]">
//                         {index + 1}
//                       </p>
//                       <span
//                         title={item.trim()}
//                         className="text-white whitespace-nowrap overflow-hidden text-ellipsis max-w-[100%]"
//                       >
//                         {item.trim()}
//                       </span>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//               <div className="absolute bottom-0 left-[15px] flex items-center justify-between mb-3 gap-2 z-[2]">
//                 <h3 className="text-[22px] font-[Lato] font-[600] text-[white]">
//                   {selectedMeal.meal_name?.[tab.type]}
//                 </h3>
//               </div>
//             </div>

//           </div>
//         </>
//       )}
//       <InfoGridCard
//         data={nutrientData}
//         columns={3}
//         gap="gap-4"
//         rounded="rounded-[20px]"
//         t={t}
//       />
//     </div>
//   );
// };

// export default DietPlanOverview;

import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { getInitialTab } from "@utils/getInitialTab";

// Import sub-components
import DietPlanOverviewHeader from "./DietPlanOverviewHeader";
import DietOverviewTabs from "./DietOverviewTabs";
import DietOverviewContent from "./DietOverviewContent";

const currentHour = new Date().getHours();

const DietPlanOverview = ({
  selectedMeal,
  selectedDay,
  selectedMeals,
  variant = "dashboard",
  showHeader = true,
  showClock = true,
  navigateTo = "/dashboard/recipe-detail",
  stateKey = "dashboard",
  tab,
  setTab,
  startDate = null,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const isCurrentMealTime = (category, type) => {
    const currentTab = getInitialTab();
    return currentTab.category === category && currentTab.type === type;
  };

  const handleCategoryChange = (newCategory) => {
    const currentTimeTab = getInitialTab();

    if (newCategory === currentTimeTab.category) {
      setTab(currentTimeTab);
    } else {
      let newType;

      if (newCategory === "meals") {
        if (currentHour >= 19) {
          newType = "dinner";
        } else if (currentHour >= 13) {
          newType = "lunch";
        } else {
          newType = "breakfast";
        }
      } else {
        if (currentHour >= 16) {
          newType = "evening";
        } else {
          newType = "afternoon";
        }
      }

      setTab({
        category: newCategory,
        type: newType,
      });
    }
  };

  const handleTypeChange = (newType) => {
    setTab((prev) => ({
      ...prev,
      type: newType,
    }));
  };

  const handleOpenRecipe = () => {
    const index = selectedMeals[selectedDay][tab.type];
    navigate(navigateTo, {
      state: {
        mealType: tab.type,
        index: index,
        day: selectedDay,
        [stateKey]: true,
        tab: tab.type,
        tabCategory: tab?.category,
        startDate,
      },
    });
  };

  useEffect(() => {
    if (location.state?.tab) {
      setTab({
        category: location?.state?.category,
        type: location.state?.tab,
      });
    }
  }, [location?.state, setTab]);

  // Text helper functions
  const getPunchLine = () => {
    switch (tab.type) {
      case "breakfast":
        return t("dietPlanDashboard.mealListing.breakfastPunchLine");
      case "afternoon":
        return t("dietPlanDashboard.mealListing.afternoonSnackPunchLine");
      case "lunch":
        return t("dietPlanDashboard.mealListing.lunchPunchLine");
      case "evening":
        return t("dietPlanDashboard.mealListing.eveningSnackPunchLine");
      case "dinner":
        return t("dietPlanDashboard.mealListing.dinnerPunchLine");
      default:
        return "";
    }
  };

  const getMealTimeText = () => {
    if (!isCurrentMealTime(tab.category, tab.type)) return "";
    switch (tab.type) {
      case "breakfast":
        return t("dietPlanDashboard.mealListing.breakfastTime");
      case "afternoon":
      case "evening":
        return t("dietPlanDashboard.mealListing.snackTime");
      case "lunch":
        return t("dietPlanDashboard.mealListing.lunchTime");
      case "dinner":
        return t("dietPlanDashboard.mealListing.dinnerTime");
      default:
        return "";
    }
  };
  const currentTimeTab = getInitialTab();

  return (
    <div className={`${variant === "dashboard" ? "p-4 lg:p-6" : ""}`}>
      <DietPlanOverviewHeader
        variant={variant}
        showHeader={showHeader}
        showClock={showClock}
        selectedDay={selectedDay}
        getMealTimeText={getMealTimeText}
        getPunchLine={getPunchLine}
      />

      <DietOverviewTabs
        tab={tab}
        isCurrentMealTime={isCurrentMealTime}
        handleCategoryChange={handleCategoryChange}
        handleTypeChange={handleTypeChange}
        currentTimeTab={currentTimeTab}
      />

      {/* Add selectedMeal prop here */}
      <DietOverviewContent
        tab={tab}
        selectedMeal={selectedMeal} // ← Missing this!
        selectedDay={selectedDay} // ← Also add selectedDay if needed
        variant={variant}
        handleOpenRecipe={handleOpenRecipe}
      />
    </div>
  );
};

export default DietPlanOverview;
